module.exports = __webpack_public_path__ + "img/waiting-courier.280d1b22.svg";